import React, { useState, useEffect } from 'react';
import './App.css';
import Loader from './components/Loader/Loader';
import StartMenu from './components/StartMenu/StartMenu';
import NavbarGame from './components/NavbarGame/NavbarGame';
import InfoPage from './components/InfoPage/InfoPage';
import GamePage from './components/GamePage/GamePage';
import FinishGame from './components/FinishGame/FinishGame';
import textContents from './data/dataInterface';
import { setTimeout } from 'timers';
import WellDone from './components/WellDone/WellDone';
import SentencePage from './components/SentencePage/SentencePage';

let imagesName = {};
let imagesArr = {}; //массив с картинками, ключ - название картинки

let rightAnswers = []; //массив признаков был сделан правильный ответ или нет
let langv = 'rus';
let isLoad = false;
let num = 0;
let gameWords = []; //слова, которые будут расположены на текущем экране
let addWords = []; //массив всех слов игры

let selectedWord = '';


    //создание массива всех слов игры без текущего слова
    function allWords(content, id, lang, callback) {
        let arr = [];
        selectedWord = content[id][lang];
        for (var key in content) {
            let curWord = content[key][lang];
            if (curWord === selectedWord) continue; //исключаем выбранное слово
            arr.push(curWord); //создание массива всех дополнит. слов 
        };
        addWords = arr.filter((elem, pos) => {  //убираем повторяющиеся значения
            return arr.indexOf(elem) === pos;
        }
        );
        shuffle(addWords);  //перемешиваем массив дополнит. слов
        callback();
    };

// словa правильные и дополнительные слова на экране
function askWords() {
    gameWords = [];
    let rightPlace = Math.floor(Math.random() * 4);
    gameWords.push({
        id: 0,
        words: selectedWord,
        fake: false,
        place: rightPlace
    });
    let num = 0;
    for (let i = 1; i < 4; i++) {
        if (num === rightPlace) num++;
        gameWords.push({
            id:i,
            words: addWords[i],
            fake: true,
            place: num
        });
        num++;
    }
};
function rightAnswer(count) {
    rightAnswers = [];
    for (let i = 0; i < count; i++) rightAnswers[i] = false;
};
function GameContent(content, callback) {
    imagesName = Object.keys(content); 
    rightAnswer(imagesName.length);
    for (let id of imagesName) {                 //чтение в кэш картинок контента, ключ - название картинки

        let urlFile = process.env.PUBLIC_URL + '/content/' + id + '.png';
        imagesArr[id] = new Image(550, 315);
        imagesArr[id].src = urlFile;
    };
    imagesArr['bgGame'] = new Image(695, 594);
    imagesArr['bgGame'].src = process.env.PUBLIC_URL + '/interface/background.jpg';
    imagesArr['bgBig'] = new Image(695, 594);
    imagesArr['bgBig'].src = process.env.PUBLIC_URL + '/interface/backgroundBig.jpg';
    imagesArr['WellDone'] = new Image(695, 594);
    imagesArr['WellDone'].src = process.env.PUBLIC_URL + '/interface/WellDone.png';
    imagesArr['FinishGame'] = new Image(695, 594);
    imagesArr['FinishGame'].src = process.env.PUBLIC_URL + '/interface/FinishGame.png';
    shuffle(imagesName);  //перемешиваем массив слов-картинок, в этом порядке будет идти текущая игра

    callback();
};

function readData() { //чтение данных 
    let address = window.top.document.location.href; //определение языка на котором находится игра
    if (address.indexOf('/fin/') > 0) langv = 'fin';

    GameContent(textContents.content, function () { isLoad = true; });
};

readData();

//Функции перемешивания масива

//вспомогательная функция
function putToCache(elem, cache) {
    if (cache.indexOf(elem) !== -1) {
        return;
    }
    var i = Math.floor(Math.random() * (cache.length + 1));
    cache.splice(i, 0, elem);
}
//функция, возвращающая свеженький, девственный компаратор
function madness() {
    var cache = [];
    return function (a, b) {
        putToCache(a, cache);
        putToCache(b, cache);
        return cache.indexOf(b) - cache.indexOf(a);
    };
}
//собственно функция перемешивания
function shuffle(arr) {
    var compare = madness();
    return arr.sort(compare);
};


export default function App() {
    const [isLoading, setIsLoading] = useState(false); //окно1,признак загрузки контента
    const [isStart, setIsStart] = useState(false); //окно2,начало игры с нуля, выбор языка
    const [isInfo, setIsInfo] = useState(false); //окно3, инструкция к игре
    const [isNavbar, setIsNavbar] = useState(false);	//окно4, верхнее меню

    const [isGame, setIsGame] = useState(false);		//окно5, слова-вопросы и поле ответа
    const [isWellDone, setIsWellDone] = useState(false);//окно6, Маша плюс МОЛОДЕЦ
    const [isSentence, setIsSentence] = useState(false);//окно7, картинка и отвеченное слово
    const [isFinish, setIsFinish] = useState(false);	//окно8,  конец игры

    const [lang, setLang] = useState(langv);
    const [step, setStep] = useState(0);
    const [imgId, setImgId] = useState(1);
    const [disabled, setDisabled] = useState(false);  // правильный ответ нажат, окна с вопросами не видны ???
    const [Answers, setAnswers] = useState(rightAnswers); //массив с указанием состояния ответа: 0 - еще нет ответа, 1 - ответ верен

   const preloadTime = (() => {
       for (let i = 0; i < 4; i++) {
           if (num > 0) break;
           if (isLoad && num === 0) {
               setIsLoading(isLoad);
              
               setImgId(imagesName[0]);
               setIsStart(true);
               num++;
               break;
           }
           setTimeout(setIsLoading, 2000, isLoad);
       }
    });
    useEffect(() => {
        setTimeout(preloadTime, 3000);
    }, [isLoading]);


    // если язык изменился
    function newDate(dataCont, curImgId, curLangv, callback) {
        allWords(dataCont, curImgId, curLangv, askWords);
        callback();
    }
    function setData() {

       // console.log('gameWords2 = ', gameWords);
    }
    

    const handleComponent = ((pri) => {
        if (pri === 'rus' && lang === 'fin') {
            setLang('rus');
            langv = lang;
            if (isGame) newDate(textContents.content, imagesName[step], pri, setData);
        };
        if (pri === 'fin' && lang === 'rus') {
            setLang('fin');
            langv = lang;
            if (isGame) newDate(textContents.content, imagesName[step], pri, setData);
        }
        if (pri === 'start') {
            shuffle(imagesName);
            rightAnswer(imagesName.length);
            setIsStart(false);
            setIsInfo(true);
            setIsNavbar(true);
            setStep(0);
            setImgId(imagesName[0]);
            setAnswers(rightAnswers);
            allWords(textContents.content, imagesName[step], lang, askWords);
        }
        if (pri === 'toStart') {
            shuffle(imagesName);
            rightAnswer(imagesName.length);
            setIsFinish(false);
            setIsStart(true);
            setIsNavbar(false);
            setIsInfo(false);
            setIsGame(false);
            setStep(0);
            setImgId(imagesName[0]);
            setAnswers(rightAnswers);
            setDisabled(false);
            setIsFinish(false);
        };
        if (pri === 'continue') {
            setIsInfo(false);
            if (!Answers[step]) setIsGame(true);
            else {
                if (step < (rightAnswers.length - 1)) setIsSentence(true);
                else setIsFinish(true);
            }
        };

        if (pri === 'info') {
            setIsInfo(true);
            setIsGame(false);
            setIsSentence(false);
            setIsFinish(false);
            setIsWellDone(false);
        };

        if (pri === 'answer') {
            setIsGame(false);
            setIsWellDone(true);
            setIsNavbar(false);
            rightAnswers[step] = true;
            setAnswers(rightAnswers);
            if ((step + 1) < rightAnswers.length) {
                setImgId(imagesName[step + 1]);
                setStep(step + 1);
                newDate(textContents.content, imagesName[step + 1], lang, setData)
                setTimeout((() => {
                    setIsGame(true);
                    setIsWellDone(false);
                    setIsNavbar(true);
                }), 3500)
            }
            else {
                setTimeout((() => {
                    setIsFinish(true);
                    setIsWellDone(false);
                    setIsStart(false);
                    setIsNavbar(true);
                }), 5000)
            }
        }
        if (pri === 'prev') {
            setIsGame(false);
            setIsSentence(true);
            setImgId(imagesName[step - 1]);
            setStep(step - 1);
        }
        if (pri === 'next') {
            setImgId(imagesName[step + 1]);
            setStep(step + 1);
            if (!Answers[step + 1]) {
                newDate(textContents.content, imagesName[step + 1], lang, (() => {
                    setIsGame(true);
                    setIsSentence(false);
                }));
            }
        }
        if (pri === 'newGame') {
            setIsFinish(false);
            rightAnswer(imagesName.length);
            newDate(textContents.content, imagesName[0], lang, setData)
            setStep(0);
            setImgId(imagesName[0]);
            setIsGame(true);
        }
 
    });

     return (
        <div className='App'>
            <div className='App-header'>
                {!isLoading ? <Loader /> : null}
                {isNavbar ? <NavbarGame lang={lang} onClick={(pri) => handleComponent(pri)} topMenu={textContents.topMenu} /> : null}
                 {isStart ? (<StartMenu lang={lang} onClick={(pri) => handleComponent(pri)} startPage={textContents.startPage} src={imagesArr['bgBig'].src} />) : null}
                {isInfo ? <InfoPage lang={lang} onClick={(pri) => handleComponent(pri)} textGame={textContents.textGame} src={imagesArr['bgGame'].src} /> : null}
                {isGame ? <GamePage step={step} disabled={disabled} gameWords={gameWords} imgId={imgId} lang={lang} src={imagesArr[imgId].src} bgSrc={imagesArr['bgGame'].src} onClick={(pri) => handleComponent(pri)} textGame={textContents.textGame} /> : null}
                 {isWellDone ? <WellDone src={imagesArr['WellDone'].src} textGame={textContents.textGame.GameOver[lang]} /> : null}
                {isSentence ? <SentencePage step={step} curWord={textContents.content[imgId][lang]} imgName={imgId} src={imagesArr[imgId].src} onClick={(pri) => handleComponent(pri)} textGame={textContents.textGame} lang={lang} bgSrc={imagesArr['bgGame'].src} /> : null}            
                 {isFinish ? <FinishGame lang={lang} onClick={(pri) => handleComponent(pri)} rightAnswer={rightAnswer} textGame={textContents.textGame} src={imagesArr['FinishGame'].src} /> : null}

            </div>
        </div>
    );
};